var MpPageContact;

(function() {
    if (!document.querySelector('#vue-contact')) {
        return;
    }

    MpPageContact = new Vue({
        el: '#vue-contact',
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,
            FORM_URL: '/contact',

            name: '',
            email: '',
            phone: '',
            contactPhone: false,
            subject: '',
            message: '',
            privacity: false,
            fsecure: '',

            errors: [],
            successMessage: '',
            validated: false,
            overlay: null,
            miniMap: null,

            isSending: false,
            isLegalShown: false,
            isMapShown: false,
            isInitialized: false,
            initialized: false,
        },
        computed: {
            nameCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.name);
            },
            emailCheck: function() {
                return !this.validated || FormValidator.isValidEmail(this.email);
            },
            phoneCheck: function() {
                return !this.validated || (!this.contactPhone && FormValidator.isEmpty(this.phone)) || FormValidator.isNumber(this.phone);
            },
            subjectCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.subject);
            },
            messageCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.message);
            },
            privacityCheck: function() {
                return (!this.validated || this.privacity);
            },
            dataForm: function() {
                return Serializer.serialize({
                    'name': this.name,
                    'email': this.email,
                    'phone': this.phone,
                    'contactPhone': (this.contactPhone) ? true : '',
                    'subject': this.subject,
                    'message': this.message,
                    'privacity': this.privacity,
                    'fsecure': this.fsecure
                });
            }
        },
        methods:{
            closeMapModal: function() {
                noScroll.off();
                this.isMapShown = false;
            },

            showMap: function() {
                noScroll.on();
                this.isMapShown = true;
            },

            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.isLegalShown = true;
                }
            },

            cleanErrors: function() {
                this.errors = [];
            },

            addError: function(errorMsg) {
                if (this.errors.length > 0) {
                    return;
                }

                this.errors.push(errorMsg);
            },

            validateForm: function() {
                /// error_data, data_ko & error_privacity
                /// are globally injected from PHP controller
                var isValid = true;

                this.cleanErrors();
                this.successMessage = '';
                this.validated = true;

                if (!this.nameCheck) {
                    this.addError(error_data);
                    isValid = false;
                }

                if (!this.emailCheck) {
                    isValid = false;
                    this.addError(data_ko);
                }

                if (!this.phoneCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.subjectCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.messageCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.privacityCheck) {
                    isValid = false;
                    this.addError(error_privacity);
                }

                return isValid;
            },

            resetForm: function() {
                this.name = '';
                this.email = '';
                this.phone = '';
                this.contactPhone = false;
                this.subject = '';
                this.message = '';
                this.privacity = false;

                this.validated = false;
                this.cleanErrors();
            },

            onSend: function(response) {
                this.isSending = false;

                if (response.data.result === 'OK') {
                    this.successMessage = response.data.message;
                    this.resetForm();
                } else {
                    this.addError(response.data.message);
                }
            },

            sendForm: function(ev) {

                if (!this.isSending && this.validateForm()) {
                    this.isSending = true;

                    axios
                        .post(this.FORM_URL, this.dataForm)
                        .then(this.onSend)
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.overlay = this.$refs.overlay;
                this.$refs.fsecure.style.display = 'none';
            },
        },
        filters: {},
        mounted: function() {
            this.init();
        },
        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        }
    });

})();
